import React from 'react';
import '../../../styling/Styles.css';
import clsx from 'clsx';
import NewPageButton from './NewPageButton';
import DeletePageButton from './DeletePageButton';
import SavePageButton from './SavePageButton';
import DuplicatePageButton from './DuplicatePageButton';
import RenamePageButton from './RenamePageButton';
import PanelBasicActions from './PanelBasicActions';
import ViewAnnotationsPanel from './ViewAnnotationsPanel';
import { clearUIelements, loadUIelements } from '../handleStoreElements';
import apiService from '../../../services/apiService';
import EnableMovementPanel from './EnableMovementPanel';
import HandleSidePannelButton from './HandleSidePannelButton';

const PagesFunctionsBar = (props) => {
  const {
    savedPageClicked,
    selectedProject,
    selectedPage,
    setSelectedPage,
    editor,
    projectNamesPages,
    setProjectNamesPages,
    savedPagesPerProject,
    setSavedPagesPerProject,
    setProject,
    anchorApplyStylingEl,
    setAnchorApplyStylingEl
  } = props;

  const newPageClicked = async (pageName, isEdit, duplicatePage) => {

    editor.runCommand('enable-navigate-page');
    if (!(selectedProject >= 0)) return;
    const projectData = JSON.parse(localStorage.getItem('data'));
    const tempProjectNamesPages = [...projectNamesPages];
    let newName = '';

    editor.Panels.getButton('panel-switcher', 'show-blocks').set('active', true);

    clearUIelements(editor);

    tempProjectNamesPages[selectedProject] = projectNamesPages[selectedProject];

    if (pageName !== undefined) 
    {
      newName = pageName;
    }

    tempProjectNamesPages[selectedProject].push(newName);
    setProjectNamesPages(tempProjectNamesPages);
    
    let newPage = {};

    if (isEdit === true) {
      newPage = await apiService.createPage(duplicatePage).then((res) => res)
    } else {
      newPage = await apiService.createPage({
        /* eslint no-underscore-dangle: 0 */
        projectId: projectData[selectedProject]._id,
        name: newName,
      });
    }

    projectData[selectedProject].pages.push(newPage);
    setProject(projectData[selectedProject]);
    // TODO: this is not needed yet it pass validation thus it will remain for a while
    localStorage.setItem('data', JSON.stringify(projectData));

    setSelectedPage(tempProjectNamesPages[selectedProject].length - 1);

    const tempSavedPagesPerProject = [...savedPagesPerProject];
    tempSavedPagesPerProject[selectedProject] = savedPagesPerProject[selectedProject];
    tempSavedPagesPerProject[selectedProject].push(true);
    setSavedPagesPerProject(tempSavedPagesPerProject);
    loadUIelements(editor, tempProjectNamesPages[selectedProject].length - 1, selectedProject);
  };

  const deletePageClicked = () => {

    editor.runCommand('enable-delete-page');
    if (selectedPage < 0) return;

    const projects = JSON.parse(localStorage.getItem('data'));
    if (projects === null) return;
    apiService
      .deletePage(
        projects[selectedProject].pages[selectedPage].pageId,
        /* eslint no-underscore-dangle: 0 */
        projects[selectedProject]._id
      )
      .then(() => {
        //  Below this line is an indecipherable code :-/ why slice and not filter
        clearUIelements(editor);
        const temp = [...projectNamesPages];
        temp[selectedProject].splice(selectedPage, 1);
        setProjectNamesPages(temp);

        projects[selectedProject].pages.splice(selectedPage, 1);
        localStorage.setItem('data', JSON.stringify(projects));

        const temp3 = [...savedPagesPerProject];
        temp3[selectedProject].splice(selectedPage, 1);
        setSavedPagesPerProject(temp3);
        setSelectedPage(-1);
        editor.stopCommand('enable-delete-page');
      })
      .catch((error) => {
        //  here it need an error page
        throw error;
      });
  };

  return (      
      <div className={clsx('panel__top')}>
        <div className={clsx('basic_functions', 'gjs-pn-panel')}>
          <div className={clsx('gjs-pn-buttons')}>
            <HandleSidePannelButton
              editor={editor}
              selectedPage={selectedPage}
            />
            <NewPageButton
              editor={editor}
              selectedPage={selectedPage}
              selectedProject={selectedProject}
              savedPagesPerProject={savedPagesPerProject}
              newPageClicked={newPageClicked}
              savedPageClicked={savedPageClicked}
            />
            <DeletePageButton
              editor={editor}
              selectedPage={selectedPage}
              deletePageClicked={deletePageClicked}
            />
            <SavePageButton
              editor={editor}
              selectedPage={selectedPage}
              savedPageClicked={savedPageClicked}
            />
            <RenamePageButton
              editor={editor}
              selectedPage={selectedPage}
              selectedProject={selectedProject}
              projectNamesPages={projectNamesPages}
              setProjectNamesPages={setProjectNamesPages}
              savedPageClicked={savedPageClicked}
            />
            <DuplicatePageButton
              editor={editor}
              selectedPage={selectedPage}
              selectedProject={selectedProject}
              savedPagesPerProject={savedPagesPerProject}
              newPageClicked={newPageClicked}
              savedPageClicked={savedPageClicked}
            />
          </div>
        </div>

        <PanelBasicActions
          editor={editor}
          selectedPage={selectedPage}
          selectedProject={selectedProject}
          anchorApplyStylingEl={anchorApplyStylingEl}
          setAnchorApplyStylingEl={setAnchorApplyStylingEl}
          projectNamesPages={projectNamesPages}
          savedPagesPerProject={savedPagesPerProject}
          setSavedPagesPerProject={setSavedPagesPerProject}
        />
        <ViewAnnotationsPanel
          editor={editor}
          selectedPage={selectedPage}
          selectedProject={selectedProject}
        />
        <EnableMovementPanel
          selectedPage={selectedPage}
        />
        <div className="device_manager" style={selectedPage < 0 ? { display: 'none' } : null}>
          {' '}
        </div>
      </div>
  );
};

export default PagesFunctionsBar;
